import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=2bc43faf&scoped=true&"
import script from "./Login.js?vue&type=script&lang=js&"
export * from "./Login.js?vue&type=script&lang=js&"
import style0 from "./Login.scss?vue&type=style&index=0&id=2bc43faf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc43faf",
  null
  
)

export default component.exports